<template>
    <div class="battery-right">
        <div class="power-chart">
            <divBox :title="'电池SOC'">
                <template>
                    <soc v-if="socShow" :soc="currentSoc" />
                </template>
            </divBox>
            <!-- <divBox :title="'电池SOH'">
                <template>
                    <div>
                        sdfsdf
                    </div>
                </template>
            </divBox> -->
        </div>

        <divBox :title="'乘用车&电压/电流监测'">
            <template>
                <div class="bat-charts" style="height: 420px;">
                    <Echart v-if="oneOptionsShow" :id="'battertSV'" :options="oneOptions"/>
                </div>
            </template>
        </divBox>

        <divBox class="power-chart1" :title="'温度监测'">
            <template>
                <div class="bat-charts" style="height: 420px;">
                    <Echart v-if="twoOptionsShow" :id="'battertTemp'" :options="twoOptions" />
                </div>
            </template>
        </divBox>
    </div>
</template>

<script>
import boxTitle from '../../components/boxTitle.vue'
import divBox from '../../components/divBox.vue'

import soc from './right-soc.vue'
// import boxList from '../../components/boxList.vue'
import { dataInterface } from '@/api/dataInterfaceApi'

import Echart from '../../components/echarts.vue'
export default {
    components: {
        boxTitle,
        divBox,
        soc,
        // boxList
        Echart
    },
    props: {
        batteryData: {
            type: Object,
            default: () => { return {} }
        }
    },
	// inject: ['batteryId'],
    inject: ['batteryObj'],
    computed: {
        computedProperty() {
            return this.batteryObj()
        }
    },
    watch: {
        batteryData(newV) {
            // debugger
            this.currentSoc = newV.currentSoc || '0'
            this.socShow = true
        },
        computedProperty(val) {
            this.batteryId = val.value
            this.oneOptionsShow = false
            this.twoOptionsShow = false
            this.socShow = false
		    this.init()
        },
    },
    data() {
        return {
            socShow: false,
            currentSoc: '',
            batteryId: '',
            allRoundData: [
                {
                    icon: 'user1',
                    title: '活跃用户数',
                    value: '366',
                    unit: '',
                    color: '#36FBFB'
                },
                {
                    icon: 'car1',
                    title: '活跃车辆数',
                    value: '366',
                    unit: '',
                    color: '#43FFB9'
                },
                {
                    icon: 'attract',
                    title: '用户粘性',
                    value: '366',
                    unit: '%',
                    color: '#36FBFB'
                },
                {
                    icon: 'car2',
                    title: '车辆粘性',
                    value: '366',
                    unit: '%',
                    color: '#43FFB9'
                }
            ],
            oneOptionsShow: false,
            oneOptions: {
                legend: {
                    textStyle: {
                        fontSize: 14,
                        color: '#fff'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {//x轴文字的配置
                        show: true,
                        textStyle: {
                            color: "#fff",
                        },
                        fontSize: 20
                    },
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {//x轴文字的配置
                        show: true,
                        fontSize: 20,
                        textStyle: {
                            color: "#fff",
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ["rgba(255, 255, 255, 0.15)"]
                        }
                    }
                },
                series: []
            },
            twoOptionsShow: false,
            twoOptions: {
                legend: {
                    textStyle: {
                        fontSize: 14,
                        color: '#fff'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {//x轴文字的配置
                        show: true,
                        textStyle: {
                            color: "#fff",
                        },
                        fontSize: 20
                    },
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {//x轴文字的配置
                        show: true,
                        fontSize: 20,
                        textStyle: {
                            color: "#fff",
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ["rgba(255, 255, 255, 0.15)"]
                        }
                    }
                },
                series: []
            }
        }
    },
    mounted() {
    },
    methods: {
        init() {
            this.getBatteryInfo()
        },
        // 电池箱-电压电流温度监测
		getBatteryInfo() {
			let _this = this
			let params = {
				"enCode": "TiDB-Energy-dianchixiang-dianyadianliuwendujiance",
				"@battery_id": _this.batteryId
			}
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if(!res || !res.length) return
                    // let data = res || 【】
                    // console.log('_this.batteryData', _this.batteryData
                    // currTotalInterVoltV1-- 充电机电压
                    // chgOutputCurr -- 充电机电流
                    // batMaxVolt -- 电池单体最高电压
                    // batMinVolt -- 电池单体最低电压
                    // batMaxTemp -- 单体最高温度
                    // batMinTemp-- 单体最低温度
                    let currTotalInterVoltV1 = {
                        name: '充电机电压',
                        type: 'line',
                        data: []
                    }
                    let chgOutputCurr = {
                        name: '充电机电流',
                        type: 'line',
                        data: []
                    }
                    let batMaxVolt = {
                        name: '电池单体最高电压',
                        type: 'line',
                        data: []
                    }
                    let batMinVolt = {
                        name: '电池单体最低电压',
                        type: 'line',
                        data: []
                    }
                    let batMaxTemp = {
                        name: '单体最高温度',
                        type: 'line',
                        data: []
                    }
                    let batMinTemp = {
                        name: '单体最低温度',
                        type: 'line',
                        data: []
                    }
                    let oneX = []
                    // debugger
                    res.map((item, i) => {
                        currTotalInterVoltV1.data.push(parseFloat(item.currTotalInterVoltV1, 10))
                        chgOutputCurr.data.push(parseFloat(item.chgOutputCurr, 10))
                        batMaxVolt.data.push(parseFloat(item.batMaxVolt), 10)
                        batMinVolt.data.push(parseFloat(item.batMinVolt), 10)
                        batMaxTemp.data.push(parseFloat(item.batMaxTemp), 10)
                        batMinTemp.data.push(parseFloat(item.batMinTemp), 10)
                        oneX.push(_this.setTime(item.ts))
                    })
                    // console.log('series', [currTotalInterVoltV1, chgOutputCurr, batMaxVolt, batMinVolt, batMaxTemp, batMinTemp] )
                    _this.oneOptions.series = [currTotalInterVoltV1, chgOutputCurr, batMaxVolt, batMinVolt]
                    _this.oneOptions.legend.data = ['充电机电压', '充电机电流', '电池单体最高电压', '电池单体最低电压']
                    _this.oneOptions.xAxis.data = oneX
                    _this.oneOptionsShow = true
                    
                    _this.twoOptions.series = [batMaxTemp, batMinTemp]
                    _this.twoOptions.legend.data = ['单体最高温度', '单体最低温度']
                    _this.twoOptions.xAxis.data = oneX
                    _this.twoOptionsShow = true
                })
                .catch((err) => {
                    console.log(err);
			    })
        },
        setTime(time) {
            let dateN = new Date(time)
            return `${dateN.getHours()}:${dateN.getMinutes()}`
        }
    }
}
</script>

<style lang="scss" scoped>
.battery-right {
    margin-top: 20px;
    
    .power-chart {
        margin-top: 6px;
        display: flex;
        > div {
            margin: 0 3px;
            &:first-child {
                margin-left: 0;
            }
            &:last-child {
                margin-right: 0;
            }
        }
    }
    .power-chart1 {
        margin-top: 50px;
    }
    .bat-charts {
        > div {
            width: 100%;
            height: 100%;
        }
    }
}
</style>